// Api - Consultas CIC Ciudadano
const hostname = window.location.hostname;
const remplazo = "#{ambiente.liberacion}#"; // Remplazo que se ejecuta durante el release : -int , -pru, -pre, -cap
const posfijoAmbiente = remplazo.length > 0 ? `-${remplazo}` : "";

const dominio = hostname.includes("localhost")
  ? `https://localhost/Bccr.Sugef.CIC_Ciudadano.API` // Ambiente de desarrollo
  : `https://${hostname}/Bccr.Sugef.CIC_Ciudadano.API`; // Ambientes

const apiConsulta = `${dominio}/ConsultaReporte/ServicioReporte`;
const apiPadron = `${dominio}/Padron`;
const apiSeguridad = `${dominio}/Seguridad`;
const version = `api-version=1.0`;

export const apiConsultaReporte = `${apiConsulta}/ObtengaReporteCrediticio?${version}`;
export const ObtengaTipoPersona = `${apiPadron}/ObtengaTiposPersona?${version}`;
export const apiObtengaTipoPersonPadron = `${apiPadron}/ObtengaTipoPersonaPadron/{identificacion}?${version}`;
export const apiObtengaDatosPersona = `${apiPadron}/ObtengaDatosPersona?${version}`;
export const apiValideIngresoUsuario = `${apiSeguridad}/ValideIngresoUsuario/{identificacion}?${version}`;
export const apiBase = dominio;

//GAUDI
const apiGaudi = process.env.REACT_APP_API_GAUDI;

export const configuracionGaudi = {
  clienteOAuth2: process.env.REACT_APP_CLIENTE_OAUTH2,
  scopeCliente: "openid cic_ciudadano offline_access",
  suscriptor: "cic_ciudadano",
  rutaRedireccionInicio: `https://${process.env.REACT_APP_NOMBRE_SERVIDOR}/ciudadano/Dashboard/`,
  rutaRedireccionCerrarSesion: `https://${process.env.REACT_APP_NOMBRE_SERVIDOR}/ciudadano/SesionDesconectada/`,
  apiAutenticador: apiGaudi + "authorize?",
  apiObtengaAccessToken: apiGaudi + "token?",
  apiCerrarSesion: apiGaudi + "endsession?",
};
